import parse from "html-react-parser";

import { useLanguage } from "~/context/LanguageContext";

import i18n from "./i18n";

export default function ArticleBody() {
  const { lang } = useLanguage();
  const t = i18n[lang];

  return (
    <>
      <section className="cs-gradient_bg_1 cs-shape_wrap_6">
        <div className="cs-shape_2">
          <div></div>
        </div>
        <div className="cs-shape_2">
          <div></div>
        </div>
        <div className="container">
          <div className="cs-height_145 cs-height_lg_80"></div>
          <h2
            className="cs-font_38 text-center cs-m0 wow fadeInUp"
            data-wow-duration="0.8s"
            data-wow-delay="0.2s"
          >
            {parse(t.title)}
          </h2>
          <div className="cs-height_90 cs-height_lg_45"></div>

          {/* First Case Study Section: Fundamentals */}
          <div className="row align-items-center cs-column_reverse_lg">
            <div className="col-lg-5">
              <h3 className="cs-font_30 cs-m0">{t.fundamentalsTitle}</h3>
              <div className="cs-height_45 cs-height_lg_30"></div>
              <p className="cs-m0">{parse(t.fundamentalsContent)}</p>
            </div>
            <div className="col-lg-6 offset-lg-1 text-center">
              <div className="cs-portfolio_img_in cs-shine_hover_1 rounded-circle">
                <img
                  src="/img/courses/case_study_img_4.webp"
                  alt="Software Design OOP"
                  className="w-100"
                />
              </div>
              <div className="cs-height_0 cs-height_lg_40"></div>
            </div>
          </div>
          <div className="cs-height_100 cs-height_lg_80"></div>

          {/* Second Case Study Section: Advanced */}
          <div className="row align-items-center">
            <div className="col-lg-6 text-center">
              <div className="cs-portfolio_img_in cs-shine_hover_1 rounded-circle">
                <img
                  src="/img/courses/case_study_img_5.webp"
                  alt="Software Design & Architecture"
                  className="w-100"
                />
              </div>
              <div className="cs-height_0 cs-height_lg_40"></div>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <h3 className="cs-font_30 cs-m0">{t.advancedTitle}</h3>
              <div className="cs-height_45 cs-height_lg_30"></div>
              <p className="cs-m0">{parse(t.advancedContent)}</p>
            </div>
          </div>
          <div className="cs-height_150 cs-height_lg_80"></div>
        </div>
      </section>
    </>
  );
}
